import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { usePublicData } from "@/lib/publicData";
import { PageHero, Container, Reveal, CtaBand } from "@/components/public/parts";
import { MapPin, Briefcase, ArrowRight } from "lucide-react";

export default function Careers() {
  const data = usePublicData();
  const jobs = data?.jobs || [];
  return (
    <>
      <Seo title="Careers | Join the Love For Mankind Team" description="Explore rewarding careers with Love For Mankind. Join a team delivering professional care with genuine human connection." path="/careers"
        jsonLd={jobs.map((j) => ({ "@context": "https://schema.org", "@type": "JobPosting", title: j.title, description: j.description, employmentType: j.type, hiringOrganization: { "@type": "Organization", name: "Love For Mankind" }, jobLocation: { "@type": "Place", address: { "@type": "PostalAddress", addressLocality: j.location } } }))} />
      <PageHero eyebrow="Join Our Team" title="Careers With Heart" sub="Build a meaningful career supporting people in your community." breadcrumbs={[{ label: "Home", to: "/" }, { label: "Careers" }]} />
      <Container className="py-16 lg:py-24">
        <div className="space-y-4">
          {jobs.length === 0 && <p className="text-muted-foreground">No open positions right now — check back soon.</p>}
          {jobs.map((j, i) => (
            <Reveal key={j.id} delay={i * 0.05}>
              <Link to={`/careers/${j.id}`} className="group flex items-center justify-between gap-6 rounded-2xl border border-border bg-card p-6 hover:border-primary/40 transition-colors" data-testid="careers-item">
                <div>
                  <h2 className="font-heading text-xl lg:text-2xl font-semibold">{j.title}</h2>
                  <div className="flex flex-wrap gap-4 mt-2 text-sm text-muted-foreground">
                    <span className="flex items-center gap-1.5"><MapPin className="w-4 h-4" /> {j.location}</span>
                    <span className="flex items-center gap-1.5"><Briefcase className="w-4 h-4" /> {j.type}</span>
                  </div>
                </div>
                <span className="shrink-0 inline-flex items-center gap-1.5 rounded-full bg-primary text-primary-foreground font-semibold px-5 py-2.5 group-hover:bg-primary/90 transition-colors">View <ArrowRight className="w-4 h-4" /></span>
              </Link>
            </Reveal>
          ))}
        </div>
      </Container>
      <CtaBand title="Don't see the right role?" sub="We're always looking for compassionate people. Send us your details." />
    </>
  );
}
